module.exports = __webpack_public_path__ + "static/media/Turnip_stew.a97e7d39.png";